import React from "react";
import { Check, Gift } from "lucide-react";

export function Stamps({ need, have = 0 }) {
  if (!need) return null;
  if (need > 12) return (
    <div className="mt-2" data-testid="offer-stamps">
      <div className="h-3 bg-white rounded-full overflow-hidden border border-emerald-200"><div className="h-full bg-emerald-500 transition-[width] duration-500" style={{ width: `${Math.min(100, (have / need) * 100)}%` }} /></div>
      <div className="text-[11px] font-semibold text-slate-600 mt-1" data-testid="offer-stamps-text">{have >= need ? "Shpërblimi yt është gati!" : `${have}/${need} vizita · edhe ${need - have}`}</div>
    </div>
  );
  return (
    <div className="mt-2" data-testid="offer-stamps">
      <div className="flex flex-wrap gap-1.5 items-center">
        {Array.from({ length: need }).map((_, i) => {
          const done = i < have, last = i === need - 1;
          return (
            <span key={i} data-testid={`stamp-${i}`} className={`w-9 h-9 rounded-full flex items-center justify-center border-2 transition-colors duration-500 ${done ? "bg-emerald-500 border-emerald-500 text-white" : last ? "border-amber-400 bg-white text-amber-500" : "border-slate-300 bg-white text-slate-400"}`}>
              {done ? <Check className="w-5 h-5" /> : last ? <Gift className="w-4 h-4" /> : <span className="text-xs font-bold">{i + 1}</span>}
            </span>
          );
        })}
      </div>
      <div className="text-[11px] font-semibold text-slate-600 mt-1" data-testid="offer-stamps-text">{have >= need ? "Shpërblimi yt është gati!" : `${have}/${need} vizita · edhe ${need - have}`}</div>
    </div>
  );
}
